import { routes } from "src/shared/routes";
import { AnalyticsHeader, FAQS, TERMS_AND_CONDITION_ADD_ON } from "./helper";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

export const stlouisblues_pass: TTeamConfig = {
  TEAM_SCHEMA: "stlouisblues_pass",
  TEAM_FULL_NAME: "St Louis Blues",
  BROWSER_TITLE: "St. Louis Blues Pass",
  CLIENT_ID: "60ba98b2d08f.seasonshare.blues-blues.us",

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#002F87",
    COLORS_SECONDARY: "#FCB514",
    ANALYTICS_HEADER: AnalyticsHeader,
    LOGOUT_ON_INVALID_SESSION: false,
    IS_INTERCOM_ENABLED: true,
    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
    },
    DEFAULT_APP_ROUTE: routes.landing,
  },

  LANDING_PAGE_SETTINGS: {
    PASS_BANNER: {
      PASS_DISPLAY_MODE: "separate",
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: false,
    },
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
      NO_UPCOMING_RENEWAL_PERIOD_MESSAGE:
        "This is the end of your pass for this season. Please check back later to purchase for next season.",
    },
  },

  IMAGES: {
    LOGO_URL:
      "https://ss-leagues.s3.amazonaws.com/NHL_2024/St.Louis_Blues_logo_transparent.png?width=56&height=56",
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION_ADD_ON,
  },
};
